// Path: src/components/chat/LoadingIndicator.tsx
// Implemented loading spinner for asynchronous operations
// 06/07/25 2:05 PM +07
import React from 'react';
import styled from 'styled-components';

const Spinner = styled.div`
  position: absolute;
  bottom: 80px;
  right: 20px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #16a34a;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LoadingIndicator: React.FC<{ isLoading: boolean }> = ({ isLoading }) => {
  return isLoading ? <Spinner /> : null;
};

export default React.memo(LoadingIndicator);